function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.994 9.514l3.374-3.36 1.25 1.244L5.994 13 .37 7.398l1.25-1.244 3.374 3.36V0h2z",
  fill: "#0B0E13",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTJweCIgaGVpZ2h0PSIxM3B4IiB2aWV3Qm94PSIwIDAgMTIgMTMiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ5LjMgKDUxMTY3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5hcnJvdy1kb3duPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlN5bWJvbHMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJJY29ucy9BcnJvdy9Eb3duIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMi4wMDAwMDAsIC0xLjAwMDAwMCkiIGZpbGw9IiMwQjBFMTMiPgogICAgICAgICAgICA8ZyBpZD0iYXJyb3ctZG93biI+CiAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iQXJyb3ciIHBvaW50cz0iOC45OTQwMDYzOCAxMC41MTQ0MzE1IDEyLjM2ODIzMzcgNy4xNTM2OTMxNSAxMy42MTgwMTI5IDguMzk4NDc2MjIgNy45OTQwMDYzOCAxNCAyLjM2OTk5OTg5IDguMzk4NDc2MjIgMy42MTk3NzkxMSA3LjE1MzY5MzE1IDYuOTk0MDA2MzggMTAuNTE0NDMxNSA2Ljk5NDAwNjM4IDEgOC45OTQwMDYzOCAxIj48L3BvbHlnb24+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==";
export { SvgComponent as ReactComponent };


// WEBPACK FOOTER //
// ./src/images/icons/arrow-down.svg